import { createFileRoute } from "@tanstack/react-router";
import { RedeemExperience } from "@/components/RedeemExperience";

export const Route = createFileRoute("/redeem/$feedbackId")({
  component: RedeemPage,
});

function RedeemPage() {
  const { feedbackId } = Route.useParams();
  return <RedeemExperience feedbackId={feedbackId} />;
}
